import classNames from 'classnames';
import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { getLangDir } from 'wix-rich-content-common';
import { s as styles } from '../CardContent-34835053.js';
import Card from '../components/Card.js';
import { ROOT } from '../dataHooks.js';
import { VERTICAL_EMBED_TYPE } from '../types.js';
import { verticalsDataBuilder } from './verticalsDataBuilder.js';
import 'prop-types';
import 'wix-rich-content-common/libs/Tooltip';
import 'wix-rich-content-common/libs/imageUtils';
import '../convertDuration.js';
import 'lodash';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const VerticalEmbedViewer = ({ settings, componentData, helpers }) => {
  const { t, locale } = useContext(RicosContext);
  const onClick = () => {
    var _a;
    return (_a = helpers.onViewerAction) == null ? void 0 : _a.call(helpers, VERTICAL_EMBED_TYPE, "Click", componentData.type);
  };
  const props = verticalsDataBuilder(componentData, t, settings.changeBaseUrl);
  const direction = getLangDir(locale);
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(styles.card, { [styles.slimLayout]: settings.slimLayout }),
        "data-hook": ROOT,
        onClick
      },
      /* @__PURE__ */ React.createElement(Card, __spreadProps(__spreadValues({}, props), { t, direction, disabled: settings.disabled }))
    )
  );
};

export { VerticalEmbedViewer };
//# sourceMappingURL=vertical-embed-viewer.js.map
